import { createRouter, createWebHistory } from "vue-router";
import store from "../store"; // Importera Vuex-store
import LoginView from "../views/LoginView.vue";
import RegisterView from "../views/RegisterView.vue";
import HomeView from "../views/HomeView.vue";
import ProfileView from "../views/ProfileView.vue";
import CompaniesView from "@/views/CompaniesView.vue";
import AdminView from "@/views/AdminView.vue";
import NotFound from "@/views/NotFound.vue";
import PrivacyPolicyView from "@/views/PrivacyPolicyView.vue";
import EmployeeView from "@/views/EmployeeView.vue";
import AddCompanyView from "@/views/AddCompanyView.vue";
import AddEmployeeView from "@/views/AddEmployeeView.vue";
import ChangePasswordView from "@/views/ChangePasswordView.vue";
import AllMeetingsView from "@/views/AllMeetingsView.vue";

const routes = [
  { path: "/", name: "home", component: HomeView },
  { path: "/login", name: "login", component: LoginView },
  { path: "/register", name: "register", component: RegisterView },
  {
    path: "/change-password",
    name: "changePassword",
    component: ChangePasswordView,
  },
  {
    path: "/profile",
    name: "profile",
    component: ProfileView,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminView,
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/add-company",
    name: "addCompany",
    component: AddCompanyView,
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/add-employee",
    name: "addEmployee",
    component: AddEmployeeView,
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/all-meetings",
    name: "allMeetings",
    component: AllMeetingsView,
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/employee",
    name: "employee",
    component: EmployeeView,
    meta: { requiresAuth: true, roles: ["employee"] },
  },
  { path: "/companies", name: "companies", component: CompaniesView },
  {
    path: "/privacy-policy",
    name: "privacyPolicy",
    component: PrivacyPolicyView,
  },
  { path: "/:pathMatch(.*)*", name: "notFound", component: NotFound },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Om användaren trycker back/forward, behåll scroll-position
    if (savedPosition) {
      return savedPosition;
    }
    // Scrolla alltid till toppen vid ny navigering
    return { top: 0 };
  },
});

// Global navigation guard
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn;
  const user = store.getters.user;

  if ((to.name === "login" || to.name === "register") && isLoggedIn) {
    return next({ name: "home" });
  }

  if (to.meta.requiresAuth && !isLoggedIn) {
    return next({ name: "login", query: { redirect: to.fullPath } });
  }

  if (to.meta.roles && (!user || !to.meta.roles.includes(user.role))) {
    // Rollen saknas eller är otillåten
    return next({ name: "home" });
  }

  next();
});

export default router;
